import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/aboutbanner";



const About = () => {
    return (

        <>
            <Header />

            <main class="main about-us-page">
               <div className="breadcrumb-wrap" id="breadcrumb-margin">
          <div className="banner" style={{minHeight:'10px'}}>
                        <img class="bg-img bg-top" src="assets/images/inner-page/banner-p.html" alt="banner" />
                        <div class="container-lg">
                            <div class="breadcrumb-box">
                                <div class="heading-box">
                                    <h1>About Us</h1>
                                </div>
                                <ol class="breadcrumb">
                                    <li><a href="/">Home</a></li>
                                    <li>
                                        <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                    </li>
                                    <li class="current"><a href="/about">About Us</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="about-section">
                    <div class="container-lg">
                        <div class="row g-0 g-lg-4 g-xl-5">
                            <div class="col-lg-7 order-2 order-lg-1">
                                <div class="align-ment">
                                    <div class="contenten-wrap">
                                        <div class="content-box">
                                            <h4 class="unique-heading">About US</h4>

                                            <p>
                                                WELBEING'S motive is to make life simpler for you by giving you access to unique and handy products that make every day easier. We use sustainable and natural materials in our products to protect the environment.
                                            </p><br />
                                            <p>&nbsp;&nbsp;&nbsp;Manufactures of Jute Bags,Tamboolam bags, Cotton Cloth Bags, Canvas & Gift Bags with customised size and Logo Started with a dream to use more sustainable products For the socitey and enviroinment around us At affordable rate for all occassions from small functions to Corporate events.
                                            </p>
                                        </div>
                                        <div class="row g-3 g-lg-2 g-xl-2 widget-list">

                                            <div class="col-12 col-sm-4">
                                                <div class="widget" style={{ height: '100%' }}>
                                                    <h4><span>01</span></h4>
                                                    <div>
                                                        <h4 class="mt-2">Sustainable products</h4>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-4">
                                                <div class="widget" style={{ height: '100%' }}>
                                                    <h4><span>02</span></h4>

                                                    <div>
                                                        <h4 class="mt-2">100% Echo Products & Quality</h4>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-4">
                                                <div class="widget" style={{ height: '100%' }}>
                                                    <h4><span>03</span></h4>

                                                    <div>
                                                        <h4 class="mt-2">100% Natural Organic Cotton</h4>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5 order-1 order-lg-2">
                                <div class="img-box">
                                    <img class="img-fluid" src="assets/img/about/about.jpg" alt="Group  Photo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Banner/>


                <section class="team-section">
                    <div class="container-lg">
                        <div class="row gx-0 gy-4 gy-sm-5 gy-md-0 g-md-0 g-lg-1">
                            <div class="col-6 col-md-3">
                                <div class="member">
                                    <div class="img-box">
                                        <div class="bg-shape bg-theme-blue border-blue"><img src="assets/img/about/1.webp" class="img-fluid" alt="member" /></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="member">
                                    <div class="img-box">
                                        <div class="bg-shape bg-theme-yellow border-yellow"><img src="assets/img/about/2.webp" class="img-fluid" alt="member" /></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="member">
                                    <div class="img-box">
                                        <div class="bg-shape bg-theme-orange border-orange"><img src="assets/img/about/3.webp" class="img-fluid" alt="member" /></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="member">
                                    <div class="img-box">
                                        <div class="bg-shape bg-theme-pink border-pink"><img src="assets/img/about/4.webp" class="img-fluid" alt="member" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="review-section about-us-review">
                    <div className="container-lg">
                        <div className="review-wrap">
                            <div className="title-box">
                                <h4 className="unique-heading">What customer say</h4>
                                <span className="title-divider1">
                                    <span className="squre"></span>
                                    <span className="squre"></span>
                                </span>
                                <p>The services provided by the officials was smooth and satisfactory. Products and goods delivered were up to satisfaction.</p>
                            </div>

                            <Swiper
                                modules={[Pagination]}
                                spaceBetween={30}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                loop={true}
                                breakpoints={{
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 20
                                    },
                                    992: {
                                        slidesPerView: 2,
                                        spaceBetween: 30
                                    }
                                }}
                                className="review-slider"
                            >
                                <SwiperSlide>
                                    <div className="comment-box">
                                        <div className="img-box">
                                            {/* <img src="/assets/images/avatar/avatar.html" alt="avatar2" /> */}
                                        </div>
                                        <div className="avatar-content">
                                            <p>"I am purchasing purses from Welbeing since the last 3 years. I love their prompt service and so far I have faced no complaints with their products."</p>
                                            <ul className="rating p-0">
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i data-feather="star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="comment-box">
                                        <div className="img-box">
                                            {/* <img src="assets/images/avatar/avatar4.html" alt="avatar2" /> */}
                                        </div>
                                        <div className="avatar-content">
                                            <p>"I am purchasing purses from Welbeing since the last 3 years. I love their prompt service and so far I have faced no complaints with their products."</p>
                                            <ul className="rating p-0">
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i data-feather="star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="comment-box">
                                        <div className="img-box">
                                            {/* <img src="assets/images/avatar/avatar5.html" alt="avatar2" /> */}
                                        </div>
                                        <div className="avatar-content">
                                            <p>"I am purchasing purses from Welbeing since the last 3 years. I love their prompt service and so far I have faced no complaints with their products."</p>
                                            <ul className="rating p-0">
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i className="fill" data-feather="star"></i></li>
                                                <li><i data-feather="star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </section>


            </main>

            <Footer />
        </>
    )
}
export default About;